// webpack-translate-loader.ts
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';

export class WebpackTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {

  }

  getTranslation(lang: string): Observable<any> {
      return this.http.get(`../assets/i18n/${lang}.json`);
  }
}